import { useRouter } from 'next/router'
import SelectSearch from 'react-select-search'
import algoliasearch from 'algoliasearch'
import Image from 'next/image'

/* assets */
import { ReactComponent as SearchIcon } from 'public/assets/icons/search.svg'

/* styling */
import styles from './_.module.css'

const INDEX_NAME = `${process.env.NEXT_PUBLIC_STAGE}_influencers`

function Search() {
  const router = useRouter()

  const getSearchResults = async (value: string) => {
    const client = algoliasearch(
      '80V7J8FKYJ',
      '90c98e688a8e49e519db220456d83f84'
    )
    const index = client.initIndex(INDEX_NAME)

    if (!value) return await Promise.resolve([])

    return index
      .search<IndividualInfluencerAttr>(value, { hitsPerPage: 10 })
      .then(result => {
        return result.hits.map(item => ({
          ...item,
          name: item.name,
          value: item.slug
        }))
      })
  }

  return (
    <div className="relative">
      <SelectSearch
        className={(key: string) => styles[`search_${key}`]}
        options={[]}
        getOptions={getSearchResults}
        placeholder="Search"
        search={true}
        debounce={500}
        printOptions="always"
        renderOption={(_, _option) => {
          const option = _option as unknown as IndividualInfluencerAttr
          const image =
            option.image.data?.attributes.url ??
            option.profileImage.data?.attributes.url

          if (!image) return

          return (
            <button
              onClick={() =>
                router.push(`/global-marketing-leaders/${option.slug}`)
              }
              className="flex items-center gap-4 | px-4 py-2"
            >
              <Image
                src={image}
                alt={option.name}
                width="128"
                height="128"
                className="rounded-full | w-16 h-16 object-cover"
              />
              <p className="text-paragraph-2 font-medium">{option.name}</p>
            </button>
          )
        }}
      />
      <SearchIcon className="absolute top-1/2 transform -translate-y-1/2 right-6" />
    </div>
  )
}

export default Search
